import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
// import ScreenshotPic from "../../../../assets/images//screenshot1.png";
// import Facebook from "../../../../assets/images/icon-facebook.svg";
import { formattedDateTime } from "../../../../utils/helper";

export const imageUrlType = {
  "NUDITY": "nudityUrl",
  "SCREENSHOT": "screenShotUrl"
};

export const appUrlType = {
  "NUDITY": "appIcon",
  "SCREENSHOT": "image"
}

export const dateTimeType = {
  "NUDITY": "nudityDateTime",
  "SCREENSHOT": "screenShotDateTime"
}

const ScreenshotDetectedText = ({
  showModal,
  closeModal,
  getLangTranslation = () => { },
  detectedTextData,
  getScreenshot,
  type = "SCREENSHOT"
}) => {
  const modalRef = useRef();
  useEffect(() => {
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);
  // const picUrlType = urlType[type]
  // console.log(detectedTextData)
  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <h6 className="modal-title text-blue-900">
              {getLangTranslation("SCREENSHOT_DETECTED_TEXT", "Detected text")}
            </h6>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body">
            <div className="alert alert-danger d-flex align-items-center gap-3 mb-6">
              <i className="icon-info-octagon text-red-100 fs-5" />
              {getLangTranslation("SCREENSHOTS_SCREEN_ALERT_DETECTED_TEXT", "Alert : $KEYWORD_ALERT$ detected on screenshot")?.replace('$KEYWORD_ALERT$', detectedTextData?.alertText)}
            </div>
            <div className=" ratio ratio-5x3 mb-3">
              <img 
                className="rounded-3"
                src={getScreenshot(detectedTextData && detectedTextData[imageUrlType[type]])} 
                alt=""
              />
            </div>
            <div className="d-flex align-items-center gap-3 mb-3">
              <div className="icon-wrap m-social">
                <img 
                  src={detectedTextData ? detectedTextData[appUrlType[type]] : ""} 
                  alt=""
                  width="30"
                />
              </div>
              <div className="d-flex flex-column">
                <h5 className="text-small text-blue-900 mb-1">{detectedTextData?.app_name}</h5>
                <span className="text-gray text-small">
                  {detectedTextData ? formattedDateTime(detectedTextData[dateTimeType[type]]) : ""}
                </span>
              </div>
              {/* <div className="icon-wrap icon-blue ms-auto pt-cursor">
                <i className="icon-download fs-5" />
              </div> */}
              {/* {console.log(detectedTextData[picUrlType])} */}
              <a
                href={getScreenshot(detectedTextData && detectedTextData[imageUrlType[type]])}
                className="icon-wrap icon-blue ms-auto pt-cursor"
              >
                {" "}
                <i className="icon-download fs-5" />
              </a>
            </div>
            <p className=" text-dark mb-0 fw-bold text-wrap text-break">
              {/* Lorem ipsum dolor sit amet consectetur. Aliquet pellentesque ut eu{" "}
              <span className="text-red-300">scelerisque</span> sed lacus
              turpis. Libero sed cursus malesuada urna id laoreet eu orci.{" "}
              <span className="text-red-300">Fermentum</span> morbi erat amet a{" "}
              <span className="text-red-300">sem</span>. Lectus vel urna non
              facilisis orci. */}
              {detectedTextData?.alertTextDetail}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenshotDetectedText;
